import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useSelector, useDispatch } from 'react-redux';
import { companyMasterAction } from '../../../redux/actions/userAction';

export default function CompanyAutoComplete(props) {
    const { Companies, setCompanies, AllCompanies, SelectedCompanies, setSelectedCompanies } = props;


    const dispatch = useDispatch();
    // useEffect(() => {
    // //   console.log(AllCompanies)
    // }, [dispatch, AllCompanies]) 
    
//    console.log(SelectedCompanies);
    return (
        <Autocomplete
            multiple
            disablePortal
            disableCloseOnSelect
            defaultValue={SelectedCompanies}
            getOptionDisabled={(options) => {
                if (Companies.length >= 5) {
                    if (!Companies.includes(options.value)) {
                        return true
                    }
                }
            }}
            onChange={(evt, newVal) => {
                var val1 = [];
                for (var a = 0; a < newVal.length; a++) {
                    val1.push(newVal[a].value);
                }
                setSelectedCompanies(newVal);
                setCompanies(val1);
            }}
            id="combo-box-demo"
            options={AllCompanies}
            sx={{ width: '100%', margin: "0.5rem 0" }}
            renderInput={(params) => <TextField {...params} label="" size='small' placeholder={Companies.length >= 5 ? null : 'Select Companies'} />}
        />
    );
}
